export default "<div class=\"content-wrapper\">\r\n  <ng-content></ng-content>\r\n</div>\r\n";